import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React from 'react';
import { BULLETED_LIST_MENU_ITEM, INDENT_MENU_ITEM, LISTS_INDENTATION_GROUP, LISTS_INDENTATION_HERO_BUTTON, LISTS_INDENTATION_MENU, LISTS_INDENTATION_MENU_SECTION, NUMBERED_LIST_MENU_ITEM, OUTDENT_MENU_ITEM, TASK_LIST_MENU_ITEM, TEXT_SECTION, TEXT_SECTION_RANK, LISTS_INDENTATION_GROUP_RANK, LISTS_INDENTATION_MENU_RANK, LISTS_INDENTATION_MENU_SECTION_RANK, TEXT_COLLAPSED_MENU, TEXT_COLLAPSED_MENU_RANK } from '@atlaskit/editor-common/toolbar';
import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';
import { getBulletedListButtonGroup } from './toolbar-components/BulletedListButtonGroup';
import { BulletedListMenuItem } from './toolbar-components/BulletedListMenuItem';
import { IndentMenuItem } from './toolbar-components/IndentMenuItem';
import { getListsIndentationGroupForInlineToolbar } from './toolbar-components/ListsIndentationGroupForInlineToolbar';
import { getListsIndentationGroupForPrimaryToolbar } from './toolbar-components/ListsIndentationGroupForPrimaryToolbar';
import { ListsIndentationHeroButton } from './toolbar-components/ListsIndentationHeroButton';
import { getListsIndentationHeroButton } from './toolbar-components/ListsIndentationHeroButtonGroup';
import { ListsIndentationMenu } from './toolbar-components/ListsIndentationMenu';
import { getListsIndentationMenu } from './toolbar-components/ListsIndentationMenuGroup';
import { MenuSection } from './toolbar-components/MenuSection';
import { NumberedListMenuItem } from './toolbar-components/NumberedListMenuItem';
import { OutdentMenuItem } from './toolbar-components/OutdentMenuItem';
import { TaskListMenuItem } from './toolbar-components/TaskListMenuItem';
export var getToolbarComponents = function getToolbarComponents(_ref) {
  var api = _ref.api,
    showIndentationButtons = _ref.showIndentationButtons,
    allowHeadingAndParagraphIndentation = _ref.allowHeadingAndParagraphIndentation;
  return expValEquals('platform_editor_toolbar_aifc_responsiveness_update', 'isEnabled', true) ? getToolbarComponentsResponsivenessUpdate({
    api: api,
    showIndentationButtons: showIndentationButtons,
    allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation
  }) : [{
    type: LISTS_INDENTATION_GROUP.type,
    key: LISTS_INDENTATION_GROUP.key,
    parents: [{
      type: TEXT_SECTION.type,
      key: TEXT_SECTION.key,
      rank: TEXT_SECTION_RANK[LISTS_INDENTATION_GROUP.key]
    }]
  }, {
    type: LISTS_INDENTATION_HERO_BUTTON.type,
    key: LISTS_INDENTATION_HERO_BUTTON.key,
    parents: [{
      type: LISTS_INDENTATION_GROUP.type,
      key: LISTS_INDENTATION_GROUP.key,
      rank: LISTS_INDENTATION_GROUP_RANK[LISTS_INDENTATION_HERO_BUTTON.key]
    }],
    component: function component(_ref2) {
      var parents = _ref2.parents;
      return /*#__PURE__*/React.createElement(ListsIndentationHeroButton, {
        api: api,
        parents: parents
      });
    }
  }, {
    type: LISTS_INDENTATION_MENU.type,
    key: LISTS_INDENTATION_MENU.key,
    parents: [{
      type: LISTS_INDENTATION_GROUP.type,
      key: LISTS_INDENTATION_GROUP.key,
      rank: LISTS_INDENTATION_GROUP_RANK[LISTS_INDENTATION_MENU.key]
    }],
    component: function component(_ref3) {
      var children = _ref3.children;
      return /*#__PURE__*/React.createElement(ListsIndentationMenu, {
        api: api,
        allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation
      }, children);
    }
  }, {
    type: LISTS_INDENTATION_MENU_SECTION.type,
    key: LISTS_INDENTATION_MENU_SECTION.key,
    parents: [{
      type: LISTS_INDENTATION_MENU.type,
      key: LISTS_INDENTATION_MENU.key,
      rank: LISTS_INDENTATION_MENU_RANK[LISTS_INDENTATION_MENU_SECTION.key]
    }].concat(_toConsumableArray(expValEquals('platform_editor_toolbar_aifc_responsive', 'isEnabled', true) ? [{
      type: TEXT_COLLAPSED_MENU.type,
      key: TEXT_COLLAPSED_MENU.key,
      rank: TEXT_COLLAPSED_MENU_RANK[LISTS_INDENTATION_MENU_SECTION.key]
    }] : [])),
    component: expValEquals('platform_editor_toolbar_aifc_responsive', 'isEnabled', true) ? MenuSection : undefined
  }, {
    type: BULLETED_LIST_MENU_ITEM.type,
    key: BULLETED_LIST_MENU_ITEM.key,
    parents: [{
      type: LISTS_INDENTATION_MENU_SECTION.type,
      key: LISTS_INDENTATION_MENU_SECTION.key,
      rank: LISTS_INDENTATION_MENU_SECTION_RANK[BULLETED_LIST_MENU_ITEM.key]
    }],
    component: function component(_ref4) {
      var parents = _ref4.parents;
      return /*#__PURE__*/React.createElement(BulletedListMenuItem, {
        api: api,
        parents: parents
      });
    }
  }, {
    type: NUMBERED_LIST_MENU_ITEM.type,
    key: NUMBERED_LIST_MENU_ITEM.key,
    parents: [{
      type: LISTS_INDENTATION_MENU_SECTION.type,
      key: LISTS_INDENTATION_MENU_SECTION.key,
      rank: LISTS_INDENTATION_MENU_SECTION_RANK[NUMBERED_LIST_MENU_ITEM.key]
    }],
    component: function component(_ref5) {
      var parents = _ref5.parents;
      return /*#__PURE__*/React.createElement(NumberedListMenuItem, {
        api: api,
        parents: parents
      });
    }
  }].concat(_toConsumableArray(!expValEquals('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true) ? [{
    type: TASK_LIST_MENU_ITEM.type,
    key: TASK_LIST_MENU_ITEM.key,
    parents: [{
      type: LISTS_INDENTATION_MENU_SECTION.type,
      key: LISTS_INDENTATION_MENU_SECTION.key,
      rank: LISTS_INDENTATION_MENU_SECTION_RANK[TASK_LIST_MENU_ITEM.key]
    }],
    component: expValEquals('platform_editor_toolbar_task_list_menu_item', 'isEnabled', true) ? function (_ref6) {
      var parents = _ref6.parents;
      return /*#__PURE__*/React.createElement(TaskListMenuItem, {
        api: api,
        parents: parents
      });
    } : undefined
  }] : []), [{
    type: OUTDENT_MENU_ITEM.type,
    key: OUTDENT_MENU_ITEM.key,
    parents: [{
      type: LISTS_INDENTATION_MENU_SECTION.type,
      key: LISTS_INDENTATION_MENU_SECTION.key,
      rank: LISTS_INDENTATION_MENU_SECTION_RANK[OUTDENT_MENU_ITEM.key]
    }],
    component: function component(_ref7) {
      var parents = _ref7.parents;
      return /*#__PURE__*/React.createElement(OutdentMenuItem, {
        api: api,
        allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation,
        showIndentationButtons: showIndentationButtons,
        parents: parents
      });
    }
  }, {
    type: INDENT_MENU_ITEM.type,
    key: INDENT_MENU_ITEM.key,
    parents: [{
      type: LISTS_INDENTATION_MENU_SECTION.type,
      key: LISTS_INDENTATION_MENU_SECTION.key,
      rank: LISTS_INDENTATION_MENU_SECTION_RANK[INDENT_MENU_ITEM.key]
    }],
    component: function component(_ref8) {
      var parents = _ref8.parents;
      return /*#__PURE__*/React.createElement(IndentMenuItem, {
        api: api,
        allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation,
        showIndentationButtons: showIndentationButtons,
        parents: parents
      });
    }
  }]);
};
var getToolbarComponentsResponsivenessUpdate = function getToolbarComponentsResponsivenessUpdate(_ref9) {
  var api = _ref9.api,
    showIndentationButtons = _ref9.showIndentationButtons,
    allowHeadingAndParagraphIndentation = _ref9.allowHeadingAndParagraphIndentation;
  return [].concat(_toConsumableArray(getListsIndentationGroupForPrimaryToolbar()), _toConsumableArray(getListsIndentationGroupForInlineToolbar()), _toConsumableArray(getListsIndentationHeroButton(api)), _toConsumableArray(getBulletedListButtonGroup(api)), _toConsumableArray(getListsIndentationMenu(allowHeadingAndParagraphIndentation, showIndentationButtons, api)));
};